import { useEffect, useState } from 'react';
import BrandLogo from '@/components/feature/BrandLogo';
import {
  communityUrl,
  ownerVkUrl,
  ownerName,
  companyInn,
  companyOgrnip,
} from '@/mocks/strategix';
import { offerContractSections } from '@/mocks/offerContract';

export default function Footer() {
  const [contractOpen, setContractOpen] = useState(false);

  useEffect(() => {
    if (!contractOpen) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setContractOpen(false);
    };

    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = '';
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [contractOpen]);

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-5 md:px-10 py-8">
        <div className="flex flex-col lg:flex-row items-start justify-between gap-8">
          <div className="flex flex-col gap-3">
            <BrandLogo href="/" />
            <p className="text-xs text-foreground-500">
              Продвижение сообществ, сайтов и каналов под ключ
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <h4 className="text-xs font-semibold text-foreground-700">
              Связаться с владельцем
            </h4>
            <a
              href={ownerVkUrl}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-vk-line text-base"></i>
              <span>{ownerName}</span>
            </a>
            <p className="text-xs text-foreground-500">
              Для отзывов, жалоб и проверки сотрудников
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <h4 className="text-xs font-semibold text-foreground-700">
              Документы
            </h4>
            <button
              type="button"
              onClick={() => setContractOpen(true)}
              className="inline-flex items-center gap-2 text-sm text-primary-700 hover:text-primary-900 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-file-text-line text-base"></i>
              <span>Договор оферта</span>
            </button>
            <p className="text-xs text-foreground-500">
              Для ознакомления
            </p>
          </div>
        </div>

        <div className="mt-8 pt-5 border-t border-background-200/70 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-x-4 gap-y-1">
            <span className="text-xs text-foreground-500">
              ИНН {companyInn}
            </span>
            <span className="text-xs text-foreground-500">
              ОГРНИП {companyOgrnip}
            </span>
          </div>

          <div className="flex items-center gap-3">
            <a
              href={communityUrl}
              target="_blank"
              rel="nofollow noopener noreferrer"
              aria-label="Сообщество STRATEGIX ВКонтакте"
              className="w-9 h-9 flex items-center justify-center rounded-md border border-background-200 text-foreground-600 hover:text-foreground-950 hover:border-primary-400 transition-colors cursor-pointer"
            >
              <i className="ri-vk-line text-base"></i>
            </a>
            <p className="text-xs text-foreground-500">© 2026 STRATEGIX</p>
          </div>
        </div>
      </div>

      {contractOpen && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-8 bg-black/60"
          onClick={() => setContractOpen(false)}
        >
          <div
            className="relative w-full max-w-2xl max-h-[85vh] overflow-hidden rounded-lg bg-background-50 border border-background-200 flex flex-col"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="flex items-center justify-between gap-4 px-6 py-4 border-b border-background-200 shrink-0">
              <h3 className="text-base md:text-lg font-semibold text-foreground-950">
                Договор-оферта
              </h3>
              <button
                type="button"
                onClick={() => setContractOpen(false)}
                aria-label="Закрыть"
                className="w-9 h-9 flex items-center justify-center rounded-md border border-background-200 text-foreground-600 hover:text-foreground-950 hover:border-primary-400 transition-colors cursor-pointer shrink-0"
              >
                <i className="ri-close-line text-lg"></i>
              </button>
            </div>

            <div className="overflow-y-auto px-6 py-5">
              {offerContractSections.map((section) => (
                <div key={section.heading} className="mb-5 last:mb-0">
                  <h4 className="text-sm md:text-base font-semibold text-foreground-950 mb-2">
                    {section.heading}
                  </h4>
                  {section.paragraphs.map((paragraph) => (
                    <p
                      key={paragraph}
                      className="text-sm text-foreground-700 leading-relaxed mb-2 last:mb-0"
                    >
                      {paragraph}
                    </p>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </footer>
  );
}